import { createSlice , createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { checkErrors } from "../../../jsx/global-functions/checkErrors";

export const getNotficationsFunc = createAsyncThunk(
    "get notfications function",
    async (api) => {
        const token = window.localStorage.getItem("token");
        const config = {
            headers: {
                Authorization: `Bearer ${token}` // Include the token in the Authorization header
            }
        }
        try {
            const response = await axios.get(api , config);
            return response.data.data;
        }
        catch (error) {
            checkErrors(error.response , error.message);
        }
        
    }
);

const getNotficationSlicer = createSlice({
    name : "get notfications slicer",
    initialState : {
        loading : null,
        data : null,
        error : false
    },
    reducers : {},
    extraReducers : (builder) => {
        builder.addCase(getNotficationsFunc.pending , (state)=>{
            state.loading = true
            state.data = null
            state.error = null
        })
        builder.addCase(getNotficationsFunc.rejected , (state)=>{
            state.loading = false
            state.data = null
            state.error = true
        })
        builder.addCase(getNotficationsFunc.fulfilled , (state , action)=>{
            state.loading = false
            state.data = action.payload
            state.error = null
        })
    }
});
export default getNotficationSlicer.reducer;